import React from 'react';

export default () => (
  <div className='custom-header'>
    <div className='custom-header__container'>
      <a
        href='https://thirdsectorsupport.wales/'
        className='custom-header__link'
      >
        <div className='custom-header__logo'></div>
        <div className='custom-header__title'>
          Cefnogi Trydydd
          <br />
          Sector <b>Cymru</b>
        </div>
        <div className='custom-header__title'>
          Third Sector
          <br />
          Support <b>Wales</b>
        </div>
      </a>
    </div>
  </div>
);
